var _path, _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSimulateRoute = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M56.67,30.68h-12.21v-11.17h-11.17V7.3c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25,1.25v12.21h-11.17v11.17H7.4c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h12.21v11.17h11.17v12.21c0,.69.56,1.25,1.25,1.25s1.25-.56,1.25-1.25v-12.21h11.17v-11.17h12.21c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25ZM41.96,41.86h-19.85v-19.85h19.85v19.85Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32.04,
  cy: 31.93,
  r: 2.51
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 45.61,
  y: 45.47,
  width: 7.78,
  height: 7.78,
  transform: "translate(-20.4 49.46) rotate(-45)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10.69,
  y: 10.58,
  width: 7.78,
  height: 7.78,
  transform: "translate(-5.96 14.54) rotate(-45)"
})));
export default SvgSimulateRoute;